import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/super-rich`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const superrichApi = {
  getBranches: (params) => instance().get('/branch', { params }),
  postBranch: (data) => instance().post('/branch', data),
  putBranch: (data) => instance().put('/branch', data),
  deleteBranch: (params) => instance().delete('/branch', { params })
}

export default superrichApi



// WEBPACK FOOTER //
// ./src/api/superrich.js